import { useSelector } from 'react-redux';

export function useSelectors() {
  const { userPermissions } = useSelector((state) => state.userPermissions);
  const { userPermissionsDomain } = useSelector((rootReducer) => rootReducer.userPermissionsDomain);
  const { notIsFirstAccess } = useSelector((state) => state.notIsFirstAccess);

  const { nameProperty } = useSelector((state) => state.nameProperty);
  const { selectedCycle } = useSelector((state) => state.selectedCycle);

  const { cycles } = useSelector((rootReducer) => rootReducer.filterDashboard);

  return {
    userPermissions,
    userPermissionsDomain,
    notIsFirstAccess,
    nameProperty,
    selectedCycle,
    cycles,
  };
}
